import http from 'services/utils/http';
import { subscribeToAngularEvent } from 'services/utils/angularUtils';

export default {
    namespaced: true,
    state: {
        data: {},
        subscribedToClearCacheEvent: false
    },
    mutations: {
        set(state, { cacheKey, steps }) {
            if (!state.data[cacheKey]) {
                state.data[cacheKey] = {};
            }
            Object.keys(steps).forEach((key) => {
                const step = steps[key];
                state.data[cacheKey][key] = { raw: { ...step }, timestamp: new Date() };
            });
        },
        clearCache: (state) => {
            state.data = {};
        },
        setSubscribedToClearCacheEvent(state, subscribedToClearCacheEvent) {
            state.subscribedToClearCacheEvent = subscribedToClearCacheEvent;
        }
    },
    actions: {
        async getWithCache({ getters, commit }, {
            path,
            payload = {}, // { applications: string[], ranges: [{min,max,key}]
            refresh = false,
            needToken = true,
            cancelToken
        }) {
            const cacheKey = `apps_${payload.applications.join(',')}`;

            const requestRanges = [];
            let responseRanges = {};
            if (!this?.state?.cvStats?.subscribedToClearCacheEvent) {
                subscribeToAngularEvent('cvManagerClearCache', () => {
                    commit('cvStats/clearCache', { api: 'cvManager' }, { root: true });
                    commit('cache/clearCache', { api: 'cvManager' }, { root: true });
                });
                commit('setSubscribedToClearCacheEvent', true);
            }

            payload.ranges.forEach((range) => {
                const key = `${range.min}_${range.max}`;
                const response = getters.getFromCache(cacheKey, key);
                if (response) {
                    responseRanges[key] = response;
                } else {
                    requestRanges.push(range);
                }
            });
            if (requestRanges.length || refresh) {
                const requestResponse = await http.post(path,
                    { applications: payload.applications, ranges: requestRanges }, needToken, { cancelToken });
                commit('set', { cacheKey, steps: requestResponse.data.dataPerRange });
                responseRanges = { ...responseRanges, ...requestResponse.data.dataPerRange };
            }

            return responseRanges;
        }
    },
    getters: {
        getFromCache: (state) => (cacheKey, key) => {
            if (state.data && state.data[cacheKey] && state.data[cacheKey][key]) {
                const apiCache = state.data[cacheKey][key];
                const tonight = new Date();
                tonight.setUTCHours(0, 0, 0, 0);
                if (apiCache.timestamp > tonight) {
                    return apiCache.raw;
                }
            }
            return null;
        }
    }
};
